"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resourcesLoaded = resourcesLoaded;
exports.message = message;
exports.submitErrorReportCompleted = submitErrorReportCompleted;
exports.toggleErrorDetails = toggleErrorDetails;
function resourcesLoaded(culture) {
    return {
        type: "main/RESOURCES_LOADED",
        payload: culture
    };
}
function message(messageInfo) {
    return {
        type: "main/MESSAGE",
        payload: messageInfo
    };
}
function submitErrorReportCompleted() {
    return {
        type: "main/SUBMIT_ERROR_REPORT_COMPLETED"
    };
}
function toggleErrorDetails() {
    return {
        type: "main/TOGGLE_ERROR_DETAILS"
    };
}
//# sourceMappingURL=actions.js.map